import React, { useState, useEffect } from "react";
import axiosConfig from "../Service/axiosConfig"
import { NavLink, useLocation } from "react-router-dom";
import Product from "../Components/Products/Product";
import { Navbar } from "../Components";
import "../Pages/wishlist.css";
import { useDispatch } from "react-redux";
import { setWishLists } from "../redux/Slices/cartSlice";
import { MdOutlineEditLocation } from "react-icons/md";
import { AiOutlineReconciliation, AiOutlineUser } from "react-icons/ai";
import { FaHeart } from "react-icons/fa";
import "./MyOrders.css";

export default function Wishlistpage() {
    let dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [isDeleted, setIsDeleted] = useState(false)
    const [Data, SetData] = useState([])
    const [filterType, setFilterType] = useState("all");
    const location = useLocation();
    let user = localStorage.getItem("userId") || localStorage.getItem("userid");

    const GetData = async () => {
        setLoading(true)
        try {
            const responce = await axiosConfig.get(`/catlog/wishlists/?user=${user}`)
            console.log(responce.data.results)
            SetData(responce.data.results)
            const formattedWishlists = responce.data.results.map(item => {
                const wishlistProduct = item.varient || item.product;
                return {
                    id: wishlistProduct?.id,
                    wish_id: item?.id,
                    type: item.type === "rental" || item.type === "rent" ? "rental" : "sale"
                };
            }).filter(item => item.id);
            dispatch(setWishLists(formattedWishlists))
            setLoading(false)
            setIsDeleted(false)
        }
        catch (error) {
            console.log(error)
            setLoading(false)
        }
    }
    useEffect(() => {
        GetData();
    }, [isDeleted])

    const normalizedData = Data.map(itemObj => ({
        ...itemObj,
        _wishlistType: itemObj.type === "rental" || itemObj.type === "rent" ? "rent" : "buy"
    }));

    const buyCount = normalizedData.filter(item => item._wishlistType === "buy").length;
    const rentCount = normalizedData.filter(item => item._wishlistType === "rent").length;

    const filteredData = filterType === "all"
        ? normalizedData
        : normalizedData.filter(item => item._wishlistType === filterType);

    return (
        <>
            <Navbar />
            <main className="account-page template-temp2">
                <div className="account-shell">
                    <aside className="account-sidebar profile-main">
                        <div className="profile-nav__details-block">
                            <div className="account-profile__img"></div>
                            <div className="account-profile__phone">
                                {localStorage.getItem("number")}
                            </div>
                            <div>{localStorage.getItem("full_name")}</div>
                        </div>
                        <nav className="profile-nav__list">
                            <ul className="list-unstyled">
                                <NavLink
                                    to="/account/orders"
                                    className={
                                        location.pathname.startsWith("/account/orders")
                                            ? "profile-nav__list-item-active"
                                            : "profile-nav__list-item"
                                    }
                                >
                                    <li className="item-text">
                                        <span className="mx-2">
                                            <AiOutlineReconciliation />
                                        </span>
                                        My Orders
                                    </li>
                                </NavLink>
                                <NavLink
                                    to="/account/addresses"
                                    className={
                                        location.pathname.startsWith("/account/addresses")
                                            ? "profile-nav__list-item-active"
                                            : "profile-nav__list-item"
                                    }
                                >
                                    <li className="item-text">
                                        <span className="mx-2">
                                            <MdOutlineEditLocation />
                                        </span>
                                        My Addresses
                                    </li>
                                </NavLink>
                                <NavLink
                                    to="/wishlist"
                                    className={
                                        location.pathname.startsWith("/wishlist")
                                            ? "profile-nav__list-item-active"
                                            : "profile-nav__list-item"
                                    }
                                >
                                    <li className="item-text">
                                        <span className="mx-2">
                                            <FaHeart />
                                        </span>
                                        Wishlist
                                    </li>
                                </NavLink>
                                <NavLink
                                    to="/logout"
                                    className={
                                             "profile-nav__list-item"
                                    }
                                >
                                    <li className="item-text">
                                        <span className="mx-2">
                                            <AiOutlineUser />
                                        </span>
                                        Logout
                                    </li>
                                </NavLink>
                            </ul>
                        </nav>
                    </aside>

                    <section className="account-content my-profile__right_rn">
                        <div className="wishlist-container" style={{ marginTop: "10px", marginBottom: "40px" }}>
                            {loading ? (
                                <div className="loader-container">
                                    <img src={require('../Components/images/loader.gif')} alt="Loading..." />
                                </div>
                            ) : (
                                <>
                                    {Data.length >= 0 && (
                                        <>
                                            <div className="wishlist-filter-bar">
                                                <button
                                                    className={`wishlist-filter-btn ${filterType === "all" ? "active" : ""}`}
                                                    onClick={() => setFilterType("all")}
                                                >
                                                    All
                                                </button>
                                                <button
                                                    className={`wishlist-filter-btn ${filterType === "buy" ? "active" : ""}`}
                                                    onClick={() => setFilterType("buy")}
                                                >
                                                    Buy
                                                    {buyCount > 0 && <span className="wishlist-filter-count">{buyCount}</span>}
                                                </button>
                                                <button
                                                    className={`wishlist-filter-btn ${filterType === "rent" ? "active" : ""}`}
                                                    onClick={() => setFilterType("rent")}
                                                >
                                                    Rent
                                                    {rentCount > 0 && <span className="wishlist-filter-count">{rentCount}</span>}
                                                </button>
                                            </div>

                                            {filteredData.length > 0 ? (
                                                <div className="catagery-items-grid">
                                                    {
                                                        filteredData.map((itemObj, index) => {
                                                            const wishlistProduct = itemObj.varient || itemObj.product;
                                                            if (!wishlistProduct) return null;
                                                            let i = { ...wishlistProduct, "slug": itemObj.slug || wishlistProduct.slug, "available": itemObj.available, _wishlistType: itemObj._wishlistType }
                                                            return (
                                                                <Product key={itemObj.id || wishlistProduct.id} item={i} index={index} user={itemObj.user?.id} id={itemObj.id} setIsDeleted={setIsDeleted} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                            ) : (
                                                <div className="wishlist-filter-empty">
                                                    <h3>No {filterType === "buy" ? "sale" : "rental"} products found</h3>
                                                    <p>You haven't added any {filterType === "buy" ? "sale" : "rental"} products to your wishlist yet.</p>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </section>
                </div>
            </main>
        </>
    )
}
